<template>
  <AtaCard class="url-info-list">
    <template #title>{{ title }}</template>
    <SandTable class="url-info-list__table" :data="tableConfig" @cell-click="handleCellClick" />
  </AtaCard>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { useStore } from 'vuex'

import emitter from 'app/emitter'

import AtaCard from '@/components/common/AtaCard.vue'
import SandTable from '@/components/report/sandTable'
import qrcodePlaceholder from '@/assets/img/report/url-qrcode-placeholder.svg'
import { getThreatLevelTag } from '@/utils/report.util'

const store = useStore()

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  list: {
    type: Array,
    default: () => {
      return []
    }
  },
  columnData: {
    type: Array,
    default: () => {
      return []
    }
  }
})

function getColumnValue(item, column) {
  if (typeof column?.formatter === 'function') {
    return column.formatter(item)
  }
  if (column?.type === 'qrcode_image') {
    return `<img src="${qrcodePlaceholder}" alt="qrcode" style="width: 40px; height: 40px; display: block; margin: 0 auto;" />`
  }
  if (column?.prop === 'threat_level') {
    return getThreatLevelTag(item?.threat_level)
  }
  return item?.[column?.prop]
}

function normalizeColumns() {
  return (Array.isArray(props.columnData) ? props.columnData : []).map((column) => {
    const isThreatLevelColumn = column?.prop === 'threat_level'
    const isQrcodeColumn = column?.type === 'qrcode_image'
    return {
      ...column,
      html: column?.html || isThreatLevelColumn || isQrcodeColumn
    }
  })
}

function handleCellClick({ row, column }) {
  if (column?.prop !== 'qex_type') return
  if (row?.qex_type === undefined || row?.qex_type === null) return
  const currentIndex = (row.index || 1) - 1
  const pageSize = store.state.report.dropped.pageSize
  const page = Math.floor(currentIndex / pageSize) + 1
  store.commit('report/SET_DROPPED_DETAIL', { md5: row.md5, page })
  emitter.emit('tabChange', 'dropped')
}

const tableConfig = computed(() => {
  const list = Array.isArray(props.list) ? props.list : []
  const columnData = normalizeColumns()

  return {
    columnData,
    tableData: list.map((item) => {
      const row = { ...item }
      columnData.forEach((column) => {
        row[column.prop] = getColumnValue(item, column)
      })
      return row
    }),
    tableProps: {
      displayLines: 1
    }
  }
})
</script>

<style lang="scss" scoped>
.url-info-list {
  margin-top: 16px;
}
</style>
